/* global __CLIENT__ */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse, serialize } from 'cookie';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import shorthash from '../../../helpers/shorthash';
import Button from '../../../common/button/Button';

// huntEndDate is stored as epoch ms; wrapping it in a Date keeps the JSON (and so the cookie hash) identical to the old Date-based state.
const getEssentialInfo = (huntAllInfos) => ({
    idHunt: huntAllInfos.idHunt,
    dateEnd: huntAllInfos.huntEndDate === undefined ? undefined : new Date(huntAllInfos.huntEndDate),
    bannerMessage: huntAllInfos.bannerMessage,
});

// If useCookie is set to false, the sign will always appear (if there is an active hunt) until the x is clicked
// when reloading the page it will always reappear (during the active hunt)
// It will never appear on the hunt page
// If useCookie is set to true, the sign will appear only until the user clicks the x.
// It will be hidden until any of the hunt data changes (aka a new hunt starts)
class CacaAoTesouroSign extends Component {
    constructor(props) {
        super(props);

        this.useCookie = false; // false: show sign on every reload (true: save in cookie and don't show again until the next hunt)

        this._setCookie = this._setCookie.bind(this);

        this._hideSign = this._hideSign.bind(this);

        this._goToHunt = this._goToHunt.bind(this);
    }

    componentDidMount() {
        this.props.checkInfoActiveHunt();

        if (__CLIENT__ && this.useCookie) {
            if (!parse(document.cookie).huntBanner) {
                this.props.setShowSign(true);
            } else {
                this.props.setShowSign(false);
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.showSign !== this.props.showSign ||
            nextProps.huntAllInfos !== this.props.huntAllInfos;
    }

    componentDidUpdate() {
        const huntEssentialInfo = getEssentialInfo(this.props.huntAllInfos);

        // check if something changed on the hunt in regard to the data in the cookie
        if (this.useCookie && shorthash(JSON.stringify(huntEssentialInfo)) !== parse(document.cookie).huntBanner) {
            this.props.setShowSign(true);

            // delete cookie
            document.cookie = serialize('huntBanner', '', {
                path: '/',
                sameSite: 'strict',
                expires: new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
            });
        }
    }

    _setCookie() {
        // separating info
        const huntEssentialInfo = getEssentialInfo(this.props.huntAllInfos);

        // generate a shorthash and set cookie with  expires date as promotions date end
        document.cookie = serialize('huntBanner', shorthash(JSON.stringify(huntEssentialInfo)), {
            path: '/',
            sameSite: 'strict',
            expires: huntEssentialInfo.dateEnd,
        });
    }

    _hideSign(event) {
        event.stopPropagation();

        if (this.useCookie) {
            // save the users choice in a cookie (the sign will be hidden until any of the hunt details change)
            this._setCookie();
        }

        // hide button
        this.props.setShowSign(false);
    }

    _goToHunt() {
        // go to hunt page
        this.props.history.push('/caca-ao-tesouro');
    }

    render() {
        const message = this.props.huntAllInfos.bannerMessage;

        if (message && this.props.showSign) {
            return (
                <div className="huntSign">
                    <Button
                        onClick={this._goToHunt}
                        title="Inicie sua caça ao tesouro aqui"
                        className="signButton"
                    >
                        {message}
                    </Button>
                    <FontAwesomeIcon icon={faTimes} onClick={this._hideSign} className="signButtonClose" width="13" title="Fechar" />
                </div>
            );
        }

        return null;
    }
}

CacaAoTesouroSign.propTypes = exact({
    checkInfoActiveHunt: PropTypes.func, // Get active hunt, independent if user is logged or not (it's  in using by sign component)
    huntAllInfos: PropTypes.object,
    showSign: PropTypes.bool,
    setShowSign: PropTypes.func,
    history: PropTypes.object,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    match: PropTypes.object,
    staticContext: PropTypes.object,
    location: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

export default withRouter(CacaAoTesouroSign);
